export enum PricingProfileStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
